module.exports = __webpack_public_path__ + "static/media/WithdrawDone.cc6ae0ab.png";